import axiosConfig from '../axiosConfig';

export const getCSRFToken = async (): Promise<string> => {
	return await axiosConfig.instance
		.post<{ csrfToken: string }>('/token/csrf')
		.then((response) => {
			return response.data.csrfToken;
		});
};
